<template>
  <div class="b-list" :style="listStyle">
    <div class="b-list-box">
      <div class="b-list-header">
        <div class="b-list-header-box">
          <div class="b-list--top-content" v-if="tableSelect">
            <b-checkbox class="b-list-checkbox"></b-checkbox>
          </div>
          <div class="b-list--top-content" :style="[column.textAlign,column.width]"
               v-for="(column,index) in columnOptions"
               :key="index">
            <div class="b-list--top-text">
              {{ column.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="b-list-body" :style="tableHeight">
        <div class="b-list-body-box">
          <div class="b-list-loading" v-if="loadingStatus">
            <div class="loading-css"></div>
          </div>
          <div class="b-list-item" v-for="(item,index) in list" :key="index">
            <div class="b-list--item-list">
              <div class="b-list--item-list-content" v-if="tableSelect">
                <b-checkbox class="b-list-checkbox"></b-checkbox>
              </div>
              <div class="b-list--item-list-content" v-for="(column,columnIndex) in columnOptions" :key="columnIndex"
                   :style="[column.color,column.textAlign,column.width,column.style]">
                <div class="b-list--item-list-text">
                  <template v-if="column.field==='index' && !column.slot">
                    {{ index + 1 }}
                  </template>
                  <template v-if="!column.slot">{{ item[column.field] }}</template>
                  <template v-else>
                    <slot v-if="column.field==='operation'" :name="column.field" :data="item">
                      {{ item[column.field] }}
                    </slot>
                    <slot :name="column.field" :data="item[column.field]" v-else>{{ item[column.field] }}</slot>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="b-list-footer">
        <div class="b-list-footer-box">
          <template>
            <slot name="footer">
              <el-pagination
                  background
                  layout="prev, pager, next"
                  :page-size="pageSize"
                  :total="total"
                  @current-change="currentChange">
              </el-pagination>
            </slot>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BList',
  props: {
    options: {
      type: Object,
      default: () => {
        return {}
      },
      require: true,
    },
    list: {
      type: Array,
      default: () => {
        return []
      },
      require: true,
    },
    // 总条数
    width: {
      type: [Number, String],
      default: '100%',
    },
    // 总条数
    total: {
      type: Number,
      default: 0,
    },
    // 每页条数
    pageSize: {
      type: Number,
      default: 15,
    },
    // 当前页
    nowPage: {
      type: Number,
      default: 1,
    },
    columns: {
      type: Array,
      default: () => {
        return []
      },
      require: true,
    },
    // old
    rowSelection: {
      type: Object,
      default: null,
    },
  },
  watch: {
    list: {
      handler (nv, ov) {
        console.log('小田', nv, ov)
        clearTimeout(this.clearLoading)
        this.loading = false
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    columnOptions () {
      return this.columns.map((column) => {
        const field = column.field || ''
        const name = column.name || field
        const width = column.width || 120
        const color = column.color || '#585858'
        const style = column.style || {}
        const slot = column.slot || false
        const textAlign = column.textAlign || 'left'
        const widthFormat = typeof width === 'number' ? `${ width }px` : width
        return {
          field,
          name,
          width: { 'width': widthFormat, 'flex': 'none' },
          color: { color: color },
          style: style,
          slot,
          textAlign: { 'text-align': textAlign },
        }
      })
    },
    /**
     * 表格显示区域高度
     * @return {{height: string}}
     */
    tableHeight () {
      const height = this.options.tableHeight || 588
      return {
        height: `${ height }px`,
      }
    },
    tableSelect () {
      return !!this.options.select
    },
    listStyle () {
      if (typeof this.width === 'number') {
        return [{ width: this.width + 'px' }]
      }
      return []
    },
    // 加载状态
    loadingStatus () {
      return this.loading && this.list.length > 0
    },
  },
  data () {
    return {
      loading: false,
      clearLoading: null,
    }
  },
  methods: {
    currentChange (page) {
      this.loading = true
      this.clearLoading = setTimeout(() => {
        this.loading = false
      }, 3000)
      this.$emit('changePage', page)
    },
  },
  mounted () {
    setTimeout(() => {
      console.log('columnFields', this.columnFields, this.columnOptions)
    })
  },
}
</script>
